import { Box, SxProps } from "@mui/material"
import { ReactElement, useEffect, useRef } from "react"

export default function HoldButton(props: {
  repeatTime: number
  whileHoldFN: () => void
  children: ReactElement
  sx: SxProps | undefined
}): ReactElement {
  const intervalRef = useRef<number | null>(null)

  useEffect(() => {
    return () => stopCounter() // Cleanup on unmount
  }, [])

  const startCounter = () => {
    if (intervalRef.current) return

    props.whileHoldFN() // Run immediately on press (optional)
    intervalRef.current = window.setInterval(() => {
      props.whileHoldFN()
    }, props.repeatTime)
  }

  const stopCounter = () => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }

  return (
    <Box
      onMouseDown={startCounter}
      onMouseUp={stopCounter}
      onMouseLeave={stopCounter}
      onTouchStart={startCounter}
      onTouchEnd={stopCounter}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...props.sx,
      }}
    >
      {props.children}
    </Box>
  )
}
